import { createFileRoute } from "@tanstack/react-router";
import { PaymentsPage } from "@/features/payments/payments-page";

export const Route = createFileRoute("/app/w/$weddingId/payments")({ component: PaymentsPage });
